import { Button, Dialog, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';
import { FC, FormEvent } from 'react';

export interface IRecoveryInputProps {
  open: boolean;
  onSubmit: (value: string) => void;
  onClose: () => void;
}

export const RecoveryInput: FC<IRecoveryInputProps> = ({ open, onSubmit, onClose }) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const values = Object.fromEntries(formData.entries()) as { code: string };

    onSubmit(values.code);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Enter recovery code</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Stack direction='row' alignItems='center' gap={2}>
            <TextField variant='outlined' size='small' name='code' autoFocus={true} />
            <Button size='large' type='submit'>
              Submit
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};
